import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DynamicDetailsListItemAdapter } from './dynamic-details-list-item';

@Injectable()
export class DynamicDetailsListService {
  public onCollapsedChanged: Subject<boolean> = new Subject<boolean>();
  public selectedItem: Subject<any> = new Subject<any>();
  public messages: Subject<any> = new Subject<any>();
  public setItemAsSelected = new Subject<DynamicDetailsListItemAdapter>();

  constructor() {}
}
